import { FieldValues, UseFormSetError } from 'react-hook-form';

export function handleAsyncFormValidation(fields: FieldValues, setError: UseFormSetError<any>) {
  if (fields) {
    Object.entries(fields).forEach(([name, message]) => {
      setError(name, { type: 'manual', message });
    });
  }
}
